import React from 'react';
import classNames from 'classnames';

import PropTypes from '../../propTypes';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as c from '../../constants';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as Fields from './Fields';

class AddressFields extends React.Component {
  static propTypes = {
    country: PropTypes.string,
    fieldsMeta: PropTypes.arrayOf(PropTypes.AddressFieldsMeta),
    onAddressSelect: PropTypes.func,
    selectedState: PropTypes.object,
    showSingleColumn: PropTypes.bool,
  };

  static defaultProps = {
    showSingleColumn: false,
  };

  render() {
    const { fieldsMeta, country, showSingleColumn } = this.props;
    const messageKey = (type, fieldMeta) =>
      `age_verification.forms.${type}.${fieldMeta.label_translation_key}`;

    if (fieldsMeta) {
      // Build the form based on provided field meta. Field meta provides
      // the translation key to be used in labels and placeholders
      const findFieldMeta = field =>
        fieldsMeta.find(meta => meta.field === field);
      const address1 = findFieldMeta(c.ADDRESS_FIELD_ADDRESS1);
      const address2 = findFieldMeta(c.ADDRESS_FIELD_ADDRESS2);
      const city = findFieldMeta(c.ADDRESS_FIELD_CITY);
      const state = findFieldMeta(c.ADDRESS_FIELD_STATE);
      const zip = findFieldMeta(c.ADDRESS_FIELD_ZIP);

      return (
        <>
          {address1 && (
            <Fields.Address1
              onAddressSelect={this.props.onAddressSelect}
              label={messageKey('labels', address1)}
            />
          )}

          {address2 && (
            <Fields.Address2 label={messageKey('labels', address2)} />
          )}

          {city && <Fields.City label={messageKey('labels', city)} />}

          <div className="row">
            {state && (
              <div
                className={classNames('col-xs-12', {
                  'col-md': !showSingleColumn,
                })}
              >
                <Fields.States
                  currentValue={this.props.selectedState}
                  placeholder={messageKey('placeholders', state)}
                />
              </div>
            )}

            {zip && (
              <div
                className={classNames('col-xs-12', {
                  'col-md': !showSingleColumn,
                })}
              >
                <Fields.Zip label={messageKey('labels', zip)} />
              </div>
            )}
          </div>

          <Fields.Country value={country} />
        </>
      );
    }

    const error = new Error(
      'Age Verification adresss field meta was not provided'
    );
    bugsnagClient.notify(error);
  }
}

export default AddressFields;
